import React, {Component} from 'react';
import AuthConnector from '../../containers/auth_container';
import {Button, Form, Grid, Image, Message, Segment} from 'semantic-ui-react'
import * as logo from '../../assets/hinchlogosolid.png';
import {requestPasswordResetLink} from "../../data/user_api";
import {APP_URL, FORGOT_PASSWORD} from "../../constants/app_routes";

class SignIn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showError: true,
            passwordReset:false,
            errors: undefined,
            resetLinkSuccess:false
        }
    }

    componentWillMount(){
        if(this.props.authenticated){
            this.props.history.replace('/dashboard');
        }
    }

    getFormDataJSON = (formdata) => {
        const data = {};
        for (let key of formdata.keys()) {
            data[key] = formdata.get(key);
        }
        return data;
    };

    handleSubmit = (event) => {
        this.setState({loggingIn:true});
        event.preventDefault();
        const formData = this.getFormDataJSON(new FormData(event.target));
        this.props.signInAction(formData, this.props.history,this.successFn);
    };

    errorMessage(errors) {
        if ((this.props.errorMessage && this.state.showError) || (errors && errors.length >0)) {
            return (
                <Message size='mini' negative onDismiss={() => {
                    this.setState({showError: false})
                }}>
                    <Message.Header>{(errors && errors.length > 0)?"Couldn't send Reset Link":"Oops! Error Logging In"}</Message.Header>
                    <p>{(errors && errors.length>0)?errors[0]:this.props.errorMessage}</p>
                </Message>
            );
        }
    }
    successMessage(){
        return (
        <Message size='mini' success>
            <Message.Header>Success sending reset link</Message.Header>
            <p>{this.state.resetLinkMessage}</p>
        </Message> )
    }

    handlePasswordReset = (e) => {
        this.setState({loggingIn:true});
        e.preventDefault();
        const formData = new FormData(e.target);
        formData.append("redirect_url",APP_URL+FORGOT_PASSWORD);
        requestPasswordResetLink(formData)
            .then((response) => {
                if(response.success) {
                    this.setState({showError:false,errors:undefined, resetLinkSuccess:true,resetLinkMessage:response.message,loggingIn:false});
                }
                else{
                    this.setState({showError:true,errors:response.error,loggingIn:false});
                }
            });
    };

    successFn = (response) => {
        let qrCode = undefined
        if (response.data){
            if(response.data.otp_qr_code){
                qrCode = response.data.otp_qr_code
            }
        }
        this.setState({loggingIn:false,qrCode:qrCode});

    };

    render() {

        return (
            <div className="login-form">
                <Grid textAlign='center' style={{height: '100%'}} verticalAlign='middle'>
                    <Grid.Column style={{maxWidth: 450}}>
                        <Image src={logo} size='medium' centered className="signin-logo"/>
                        {this.state.resetLinkSuccess && this.successMessage()}
                        {!this.state.passwordReset ? <Form onSubmit={this.handleSubmit}>
                            <Segment>
                                {this.props.errorMessage && this.errorMessage()}
                                <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address'
                                             name="email" id="name" required/>
                                <Form.Input fluid icon='lock' iconPosition='left' placeholder='Password'
                                            type='password'  name="password" id="password"
                                            required/>
                                <Form.Input label="OTP Code (ADMIN ONLY)" fluid icon='hash' iconPosition='left' placeholder='Six Digit Code from Authenticator App'
                                type='number'  name="otp_attempt" id="otp_attempt"/>
                                <Button primary fluid size='large' loading={this.state.loggingIn} disabled={this.state.loggingIn}>Login</Button>
                                <p className="format-bold pad-all icon-button" style={{color:'teal'}} onClick={() => {this.setState({passwordReset:true})}}>Forgot Password?</p>
                            </Segment>
                        </Form>:<Form onSubmit={this.handlePasswordReset}>
                            <Segment>
                                <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address'
                                            name="email" id="name" required/>
                                <Button primary fluid size='large' loading={this.state.loggingIn} disabled={this.state.loggingIn} >Send Password Reset Link</Button>
                                <p className="format-bold pad-all icon-button" style={{color:'teal'}} onClick={() => {this.setState({passwordReset:false})}}>Login Instead?</p>
                            </Segment>
                        </Form>}

                            {this.state.qrCode && <Segment>
                                <Message>Scan the below QR Code into your authenticator App, this will not be shown again. As admin you will need this to log in.</Message>
                                <Image style={{margin:"auto"}} size="huge" src={this.state.qrCode}/></Segment>}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default AuthConnector(SignIn);


// WEBPACK FOOTER //
// ./src/views/auth/signin.js